<template>
  <div class="card OrderDetails">
    <div class="card-header OrderDetails__header" v-if="date">
      <small>{{ fromNow }}</small>
      {{ formatedData }}
    </div>

    <div class="card-header OrderDetails__header__address" v-if="location">
      <span class="location">{{ location.address }}</span>
      <span class="change">
        <button class="btn" @click="onChangeLocation">
          <i class="fa fa-map-signs mr-2" />
          <small>CAMBIAR</small>
        </button>
      </span>
    </div>
    <div class="card-header OrderDetails__header__address" v-else>
      <span class="location">LO PASARÉ A BUSCAR</span>
      <span class="change">
        <button
          class="btn"
          @click="onChangeLocation"
          v-if="showActions && editable"
        >
          <i class="fa fa-map-signs mr-2" />
          <small>CAMBIAR</small>
        </button>
      </span>
    </div>
    <div class="card-body OrderDetails__body details" v-if="location">
      <div class="OrderDetails__body__total">
        <small>PEDIDO</small>
        {{ totalPedido }}€
      </div>
      <div class="OrderDetails__body__total" v-if="showActions">
        <small>ENVIO</small>
        {{ totalSendPrice }}€
      </div>
    </div>
    <div class="card-body OrderDetails__body">
      <div class="OrderDetails__body__total">
        <small>TOTAL</small>
        {{ totalTotal }}€
      </div>
      <div class="btn btn-success" @click="sendOrder" v-if="showActions">
        <i :class="`fa fa-${buttonIcon}`" />
        {{ buttonText }}
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  props: {
    editable: { default: true },
    showActions: { default: true },
    order: { type: Array },
    editable: { type: Boolean, default: false },
    buttonText: { type: String, default: 'ENVIAR PEDIDO' },
    buttonAction: { type: Function },
    buttonIcon: { type: String, default: 'paper-plane' },
    date: { type: Number },
    location: { type: Object },
  },
  data() {
    return {
      totalSendPrice: 0,
    }
  },
  computed: {
    fromNow() {
      return moment(this.date).fromNow()
    },
    formatedData() {
      return moment(this.date).format('dddd DD MMMM - HH:mm[h]')
    },
    totalTotal() {
      return (Number(this.totalPedido) + Number(this.totalSendPrice)).toFixed(2)
    },
    totalPedido() {
      let total = 0
      const order = this.order
      order.forEach((p) => {
        const uds = Number(p.UDS)
        let pvp = p.PVP
        const format = p.FORMAT
        if (format && Number(format.PVP) > 0) pvp = Number(format.PVP)
        total += Number(pvp) * uds
        if (p.EXTRAS)
          p.EXTRAS.forEach((e) => {
            if (e.extras)
              e.options.forEach((o) => {
                total += o.INCPRECIO || 0
              })
          })
      })

      const order_location = this.$store.getters.order_location
      this.totalSendPrice = order_location && total < 35 ? 5 : 0

      /** check online api for price
      const location = this.$store.getters.order_location
      if (location && location.address && location.destination) {
        this.$store
          .dispatch('getSendPrice')
          .then(result => {
            this.totalSendPrice = Number(result).toFixed(2)
          })
          .catch(error => {
            console.error('getSendPrice', error)
          })
      } */

      return total.toFixed(2)
    },
  },
  methods: {
    async onChangeLocation() {
      const res = await window.confirm(
        '¿QUIERES CAMBIAR LA DIRECCIÓN DE ENTREGA?'
      )
      if (res) this.$router.push('/location?change=true')
    },
    sendOrder() {
      this.$emit('sendOrder', this.totalPedido)
    },
  },
}
</script>

<style lang="scss">
.OrderDetails {
  @media screen and (max-width: 340px) {
    font-size: 0.82rem !important;
  }
  &__header {
    background-color: white;
    text-transform: uppercase;

    &__address {
      align-items: center;
      display: flex;

      @media screen and (max-width: 340px) {
        padding: 0.4rem;
        .change {
          flex: 1;
          .btn {
            display: block;
            width: 100%;
          }
        }
      }

      .location {
        flex: 1;
      }
    }

    small {
      display: block;
      font-size: 0.82rem;
    }
  }

  &__body {
    display: flex;

    .btn {
      display: flex;
      align-items: center;
      font-size: 0.92rem;
      i {
        margin-right: 0.6rem;
      }
    }

    &.details {
      padding: 0.89rem 1.25rem;
      background-color: #f2f2f2;

      @media screen and (max-width: 340px) {
        padding: 0.4rem;
      }
      .OrderDetails__body__total {
        font-size: 1.1rem;
        @media screen and (max-width: 340px) {
          font-size: 1rem;
        }
      }
    }

    @media screen and (max-width: 340px) {
      padding: 0.4rem;
    }

    &__total {
      flex: 1;
      font-size: 1.6rem;
      @media screen and (max-width: 340px) {
        font-size: 1rem;
      }

      small {
        font-size: 0.72rem;
        display: flex;
        @media screen and (max-width: 340px) {
          font-size: 0.62rem;
        }
      }
    }
  }
}
</style>
